import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '@env';
import {CarCondition, CreditScoreType, ServerResponse} from '@shared/interfaces';
import {Database, get, ref} from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  headers: HttpHeaders;
  apiUrl: string;

  constructor(private http: HttpClient, private db: Database) {
    this.apiUrl = environment.apiUrl;
  }

  getUrl(url): string {
    return `${this.apiUrl}/${url}`;
  }

  decodeVin(vin): Promise<ServerResponse> {
    return this.http.post<ServerResponse>(this.getUrl('utilities/decode-vin'), {vin})
      .toPromise();
  }

  createShortLink(url) {
    return this.http.post<ServerResponse>(this.getUrl('utilities/shorten-link'), {url})
      .toPromise();
  }

  async getInterestRate(state: string, creditType: CreditScoreType, carCondition: CarCondition): Promise<number> {
    const path = `stateInterestRates/data/${state}/${creditType}/${carCondition}`;
    const dbRef = ref(this.db, path);
    return (await get(dbRef)).val();
  }
}
